@if (auth.isLoggedIn()) {
  <app-alert
    variant="info"
    title="Already signed in"
    message="You are already signed in."
    [showLink]="true"
    linkHref="/"
    linkText="Go to home"
  ></app-alert>
} @else {
  <div class="flex items-center justify-center w-full min-h-screen lg:min-h-full p-6 sm:p-10">
    <div class="w-full max-w-md p-6 sm:p-8 bg-white border border-gray-200 rounded-2xl shadow-lg dark:bg-gray-900 dark:border-gray-800">
      <div class="mb-6 text-center">
        <a routerLink="/" class="inline-flex items-center justify-center mb-2">
          <img src="/images/logo/auth-logo.svg" alt="Logo" class="h-8" />
        </a>
        <h1 class="text-xl font-semibold text-gray-900 dark:text-white">Welcome back</h1>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Sign in to continue to your account</p>
      </div>

      <form (ngSubmit)="onSignIn()" class="space-y-6">
        <div>
          <app-label>Username <span class="text-error-500">*</span></app-label>
          <input
            type="email"
            placeholder="you@example.com"
            [(ngModel)]="username"
            name="username"
            class="form-input"
            required
          />
        </div>

        <div>
          <app-label>Password <span class="text-error-500">*</span></app-label>
          <div class="relative">
            <input
              [type]="showPassword ? 'text' : 'password'"
              placeholder="Enter your password"
              [(ngModel)]="password"
              name="password"
              class="form-input pr-10"
              required
            />
            <button type="button" (click)="togglePasswordVisibility()" class="absolute z-30 -translate-y-1/2 right-3 top-1/2 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300">
              <span class="sr-only">Toggle password visibility</span>
              <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.5a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21" />
              </svg>
            </button>
          </div>
        </div>

        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <app-checkbox [(checked)]="isChecked" label="Keep me logged in" />
          </div>
          <a routerLink="/reset-password" class="text-sm text-brand-500 hover:text-brand-600 dark:text-brand-400">Forgot password?</a>
        </div>

        <app-button [disabled]="loading" size="sm" className="w-full" (btnClick)="$event.preventDefault(); onSignIn()">
          @if (loading) { Signing in… } @else { Sign in }
        </app-button>

        @if (errorMsg) {
          <p class="text-sm text-error-500">{{ errorMsg }}</p>
        }

        @if (successMsg) {
          <app-alert variant="success" title="Success" [message]="successMsg"></app-alert>
        }
      </form>
    </div>
  </div>
}
